/*
 * Adds the "+" buttons inside the cart drawer's "You might also like this"
 * carousel. Uses a single document-level delegated click listener so it
 * keeps working after the drawer re-renders its contents on every cart
 * update (inline <script> tags inside replaced innerHTML never re-run).
 */
(function () {
  function handleAdd(event) {
    var button = event.target.closest('.cart-drawer__recommend-add');
    if (!button || button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var cartDrawer = document.querySelector('cart-drawer');
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    var config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

    if (config.headers) {
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
    }

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error(response.description || response.message);
          return;
        }
        if (cartDrawer) {
          if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      });
  }

  document.addEventListener('click', handleAdd);
})();
